import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row, Button, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { UserConsumer } from "../../UserContext";
import Header from "../../components/Header";
import moment from "moment";
import { MyProfile_API } from "./MyProfile_API";
import { Routes } from "../../configurations/config";

function MyProfile() {
	let token = null;
	const history = useHistory();
	const [employeeInfo, setEmployeeInfo] = useState(null);

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		axios
			.get(`${MyProfile_API.GetMyProfile}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setEmployeeInfo(data);
				}
			});
	}, []);

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="My Profile"
								headerBorder="false"
								navigateBack={() => history.goBack()}
							/>
							{employeeInfo && (
								<>
									<div className="formInfoContainer my-3">
										<div className="formInfoContainerHeader ">
											<Label sm={12}>
												Employee Information
											</Label>
										</div>

										<Col>
											<Row className="py-2 px-2">
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Name</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.employeeName
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Employee Code</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.employeeCode
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Employee Login
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.employeeLogin
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Supervisor Name
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.supervisorName
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Department Name
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.departmentName
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Contact No.</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.emergencyContactPhoneNumber2
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Emergency Contact
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.emergencyContactName
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Emergency Contact
															No.
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.emergencyContactPhoneNumber1
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Passport No.</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{employeeInfo.passportNumber
															? employeeInfo.passportNumber
															: "N/A"}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>
															Passport Expiry Date
														</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{employeeInfo.passportExpiryDate
															? moment(
																	employeeInfo.passportExpiryDate
															  ).format(
																	"DD/MM/YYYY "
															  )
															: "N/A"}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>BloodGroup</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{employeeInfo.bloodGroup
															? employeeInfo.bloodGroup
															: "N/A"}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Address</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{
															employeeInfo.emergencyContactAddress
														}
													</p>
												</Col>
												<Col md={3} lg={2}>
													<div className="formDetailHeader">
														<div>Linkedin URL</div>
													</div>
												</Col>
												<Col md={3} lg={4}>
													<p className="formValueContainer">
														{employeeInfo.linkedInProfileURL ? (
															<a
																href={
																	employeeInfo.linkedInProfileURL
																}
																target="_blank"
																rel="noopener noreferrer"
																id="attLink"
																className="formValueContainer"
																style={{
																	textDecoration:
																		"underline",
																}}
															>
																{
																	employeeInfo.linkedInProfileURL
																}
															</a>
														) : (
															"N/A"
														)}
													</p>
												</Col>
											</Row>
										</Col>
									</div>
									<div className="formInfoContainer">
										<div className="formInfoContainerHeader">
											<Label sm={12}>
												Employee Leave Information
											</Label>
										</div>
										<Col>
											<Row className="py-2 px-2">
												<Col sm={1} md={1} lg={2}>
													<div className="formDetailHeader">
														<div>Sick Leave</div>
													</div>
												</Col>
												<Col sm={1} md={1} lg={2}>
													<p className="formValueContainer">
														{employeeInfo.sickLeave}
													</p>
												</Col>
												<Col sm={1} md={1} lg={2}>
													<div className="formDetailHeader">
														<div>Annual Leave</div>
													</div>
												</Col>
												<Col sm={1} md={1} lg={2}>
													<p className="formValueContainer">
														{
															employeeInfo.annualLeave
														}
													</p>
												</Col>
												<Col sm={1} md={1} lg={2}>
													<div className="formDetailHeader">
														<div>
															Compensation Leave
														</div>
													</div>
												</Col>
												<Col sm={1} md={1} lg={2}>
													<p className="formValueContainer">
														{
															employeeInfo.compensationLeave
														}
													</p>
												</Col>
											</Row>
										</Col>
									</div>
									<div className="btns">
										<Button
											type="submit"
											className="approve-btn leftBtn"
											onClick={() =>
												history.push(Routes.EditProfile)
											}
											style={{
												paddingLeft: "12px",
												paddingRight: "12px",
												width: "fit-content",
											}}
										>
											Edit Profile
										</Button>
									</div>
								</>
							)}
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default MyProfile;
